import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import SuperAdminPageLayout from '../../../layout/SuperAdminPageLayout';
const CreateEditorPage = () => {
    const { t } = useTranslation();
    return (_jsx(SuperAdminPageLayout, { title: `${t('admin.create_new_editor')}.`, formType: 'create', unit: 'editor' }));
};
export default CreateEditorPage;
